__turbopack_context__.v({
  "newOrderCard": "CeaI8W_newOrderCard",
  "rightContainer": "CeaI8W_rightContainer",
  "skeletonContainer": "CeaI8W_skeletonContainer",
  "wrapper": "CeaI8W_wrapper",
});
